import { render, staticRenderFns } from "./HeaderMobile.vue?vue&type=template&id=620ed0dd&"
import script from "./HeaderMobile.vue?vue&type=script&lang=js&"
export * from "./HeaderMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports